var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[_c('vue-plyr',{ref:"plyr",attrs:{"options":_vm.options}},[(_vm.videoType === 'html5')?[_vm._t("default")]:_c('div',{attrs:{"data-plyr-provider":_vm.videoType,"data-plyr-embed-id":_vm.videoKey}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }